import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {createSelector} from "reselect";

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

/**
 * Component for drawing county borders within a specific state svg chart.
 *
 * The borders are separated so that the can be drawn on top on the colored paths
 * and dont interfere with mouse events.
 *
 * Stroke color is defined inline to prevent css dependency during export.
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property stateFips - numeric state fips value to retrieve state county shapes
 * @property strokeColor - string hex color value for the drawn path stroke def. #373737
 *
 * @example
 * return (
 *   <StateCountyBorders
 *     width={500}
 *     height={500}
 *     stateFips={1}
 *   />
 * )
 */
export default class StateCountyBorders extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    strokeColor: PropTypes.string,
    stateFips: PropTypes.number
  };

  static defaultProps = {
    strokeColor: '#373737'
  }

  getFips = (props) => props.stateFips
  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getTopography = createSelector(
    [this.getFips],
    (fips) => topoUtils.getStateTopography(fips)
  )

  getPath = createSelector(
    [this.getFips, this.getWidth, this.getHeight],
    (fips, width, height) => geoUtils.getAlbersStatePath(fips, width, height)
  )

  getStrokeWidth = createSelector(
    [this.getWidth],
    (width) => width > 500 ? 1 : 0.75
  )

  render() {
    const {strokeColor} = this.props;
    const topo = this.getTopography(this.props);
    const path = this.getPath(this.props);
    const strokeWidth = this.getStrokeWidth(this.props);

    return (
      <g className="StateCountyBorders">
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d={path(topo.borders)}
        />
      </g>
    )
  }
}
